import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { AgentService } from '../services/agent.service';
import { Component, Input, OnInit } from '@angular/core';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { PageHeader } from 'src/app/models/common/page-header';

@Component({
  selector: '',
  template: '',
})
export class AgentBankBranchSearchHandler extends BaseSearchComponent<AgentService> implements OnInit {
  @Input() searchCriteriaData;
  public searchName: string;
  // public searchCriteriaData = {
  //   'AgentMasterDO.branchId': null,
  //   'AgentMasterDO.channelCd': null,
  //   'AgentMasterDO.parentAgencyId': null,
  // };
  public isAdvanceSearchDisplayed: boolean;
  public item: any;
  isSearchListDisplayed: boolean;
  isAgentNameSelected: boolean;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    this.searchName = 'SearchBankBranch';
    this.isSearchListDisplayed = false;
    this.isAgentNameSelected = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.service.responseIO.data.Entity.agentName = null;
    this.isSearchListDisplayed = false;
    this.searchCriteriaData = null;
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search -Bank Branch';
    return header;
  }
}
